<template>
        <div class="edits setting">
            <div class="setting-h1" v-if="canAccess('enterprise-my-account')">
                Company Logo
            </div>
            <div class="setting-h1" v-else>
                Profile Picture
            </div>
            <div class="setting-h2" v-if="canAccess('enterprise-my-account')">
                Update your company logo image
            </div>
            <div class="setting-h2" v-else>
                Change your profile picture
            </div>
            <div class="upload-section">
                <div class="upload-control">
                    <img class="display-picture" :src="displayImage" v-if="displayImage != null" />
                    <img class="display-picture" :src="default" v-else/>
                    <button class="float-btn change" title="Change Profile" @click="selectImage">
                        <EditIcon class="icon-img"/>
                        <input type="file"
                        ref="profileImage"
                        @change="handleFileChange"
                        accept=".jpg, .jpeg, .png, image/jpeg, image/png"
                        hidden/>
                    </button>
                    <button class="float-btn delete" title="Remove Picture" @click="deleteImage" :disabled="loading">
                        <TrashIcon class="icon-img"/>
                    </button>
                </div>
            </div>
        <div class="errors-section">
              <!-- errors -->
        
             <SystemMessage v-for="error in errors" :message="error"/>
        
        <!-- errors --> 
        </div>
        <LoadingIndicator v-if="loading"/>
        </div>
        <ImageCropperModal
            ref="cropperModal"
            :title="modal.caption"
            :button-label="modalButtonLabel"
            :file="file"
            :modal-id="modalId"
            :update-display-picture="updateDisplayPicture"/>
</template>
<script>
import { canAccess as authCanAccess } from '@/services/authService';
import { deleteProfilePictureAsync,
    getMyProfilePictureAsync
 } from '@/services/userProfileService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import ImageCropperModal from '@/components/modals/ImageCropperModal.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import TrashIcon from '@/components/IconComponents/TrashIcon.vue';
import EditIcon from '@/components/IconComponents/EditIcon.vue';
export default {
    components:{
        LoadingIndicator,
        ImageCropperModal,
        SystemMessage,
        TrashIcon,
        EditIcon
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
            modal:{
                caption:"Crop Image"
            },
            cropperModal: null,
            errors:[],
            loading:false,
            hasErrors:false,
            modalButtonLabel: 'Save',
            modalId:"cropImage",
            file:null,
            displayImage: null,
            default: new URL('@/assets/images/profile_picture.png', import.meta.url).href
            
        }
    },
     mounted(){
        
        this.loadProfilePicture();
    },
    created(){
          // Hydrate local user object from Vuex
        const authUser = this.$store.getters['auth/getAuthenticatedUser'];
    },
    methods:{
        async loadProfilePicture(){
            try{
            let img = await getMyProfilePictureAsync();
            this.displayImage = img;
            }catch(e){
                this.displayImage = this.default;
            }
        },
        canAccess(path){
            return authCanAccess(path);
        },
        selectImage(){
            this.$refs.profileImage.click();
        },
        handleFileChange(event){
            this.file = event.target.files[0];
            this.showModal();
        },
        closeModal(){
            this.$refs.cropperModal.hide();
            
        },
        showModal(){
            this.$refs.cropperModal.show();
           
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
        updateDisplayPicture(image){
            this.displayImage = image;
        },
    async deleteImage(){
        try{
            this.resetOnNewSubmit();
            var data = await deleteProfilePictureAsync();
            this.loading = false;
            if(data.success){
                this.displayImage = null;
        }else{
             throw new Error(data.message, {cause: data.caption})
        }
        }catch(e){
            this.loading = false;
            this.errors.push(e.message);
            this.hasErrors = true;
        }     
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
 
   }
    

}
</script>
<style scoped>

.edit-profile{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

.display-picture{
    height:10rem;
    /* border:2px solid #989898; */
    border-radius:100px;
    position:relative;
}

.float-btn{
    position:absolute;
    height:2rem;
    width:2rem;
    border:0px;
    border-radius: 100px;

}

.icon-img{
    margin-top:-0.26rem;
    margin-left: -0.1rem;
    height:1.1rem;
    color:var(--page-header);
}

.icon-img:first-child{
    
}

.icon-img:last-child{
    margin-left: -0.12rem;
    color:var(--red);
}

.change{
    margin-top: -0.1rem;
    transform: translate(-9rem,8rem);
    background:var(--nav);
}



.delete{
    background:var(--nav);
    transform: translate(-2rem,0.9rem);
    
}



.upload-section{
    display:flex;
    justify-content: center;
    margin-bottom:2rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}
}
</style>